export default {
  contractMission: {
    contractMission: {
      title: ({ plural }) => plural(["Misión", "Misiones"]),
      aiProposal: "Propuesta IA",
      activitiesLinked: ({ named }) => `${named("count")} actividad(es) vinculada(s)`,
      levelOfAchievement: "Nivel de realización",
      validate: "Validar esta misión",
      decline: "Rechazar",
      merge: "Fusionar en...",
      defined: "Misiones definidas",
      no_missions: "No hay misiones definidas en este contrato.",
      import: "Importar la ficha de misión",
      import_from_sheet: "Empezar a añadir a partir de una ficha de misión",
      empty_no_sheet:
        "No hay misiones definidas. Importe una ficha de misión para empezar el seguimiento del aprendiz.",
      empty_no_sheet_no_ia: "No hay misiones definidas.",
      empty_no_sheet_cta: "Importar una ficha de misión",
      empty_has_sheet:
        "Se ha importado una ficha de misión. Inicie la extracción para convertir su contenido en misiones a seguir.",
      empty_has_sheet_cta: "Iniciar la extracción",
      no_ia_alert: "Defina y siga las misiones de su alumno en prácticas/aprendiz en esta pestaña",
      no_ia_alert_description: "Añadir una misión para su alumno en prácticas/aprendiz",
    },
    import: {
      title: "Fragmentación de la ficha de misión",
      intro: "La IA identifica y reformula las misiones de la ficha — usted elige cuáles publicar.",
      existing_sheet: "Ficha de misión",
      upload_pdf: "Subir un PDF",
      free_text: "O introducir el contenido directamente",
      free_text_placeholder: "Pegue o escriba el contenido de su ficha de misión…",
      or: "o",
      or_replace: "o cargar otra ficha",
      has_file_alert: "Ficha importada desde el expediente de inscripción",
      split_failed: "La fragmentación automática no ha funcionado. Por favor, vuelva a iniciar la fragmentación.",
      launch: "Iniciar la extracción",
      loading_title: "Fragmentación en curso...",
      loading_subtitle: "La IA analiza y reformula las misiones",
      missions_proposed: "misión/misiones propuesta(s)",
      validate_all: "Validar todo",
      results_actions: "Acciones sobre las misiones propuestas",
      validate: "Validar",
      edit: "Modificar",
      remove: "Eliminar",
      confirm_edit: "Confirmar la modificación",
      field_name: "Nombre de la misión",
      field_description: "Descripción de la misión",
      no_missions: "No se han propuesto misiones.",
      publish: ({ named }) => `Publicar ${named("count")} misión/misiones`,
      publish_success: ({ named }) => `${named("count")} misión/misiones publicada(s) con éxito`,
      removal_announcement: ({ named }) =>
        `Misión "${named("name")}" eliminada. ${named("count")} misión/misiones propuesta(s) restante(s).`,
    },
    banner: {
      title: "Se ha importado una ficha de misión desde el expediente de inscripción",
      subtitle: "Divida esta ficha en misiones para seguir el progreso del aprendiz a lo largo de la alternancia",
      import: "Proceder con la importación",
      import_tooltip: "Abrir el modal de fragmentación de la ficha de misión",
      later: "Más tarde",
      later_tooltip: "Ocultar este banner durante esta sesión",
    },
  },
};
